module.exports = __webpack_public_path__ + "540c362640dc7d957b3185bcbb818e6f.jpg";